export default {
  UPDATE_USER: 'UPDATE_USER',
  RESET_USER: 'RESET_USER',
};
